import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  padding: 20px;\n  bottom: 0;\n  left: 0;\n  right: 0;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  position: sticky;\n  top: 0;\n  left: 0;\n  right: 0;\n  margin-bottom: 10px;\n  background-color: white;\n  z-index: 1;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  padding: ", " 30px 0;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  top: 70px;\n  bottom: 0;\n  right: 0;\n  left: 0;\n  position: fixed;\n  display: grid;\n  overflow: auto;\n  -webkit-overflow-scrolling: touch;\n  display: flex;\n  flex-direction: column;\n  background-color: ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../utils/styling/styled-components';
var Container = styled.div(_templateObject(), function (props) {
  return props.theme.colors.white;
});
var Content = styled.div(_templateObject2(), function (props) {
  return props.hasNavigation ? '0' : '30px';
});
var Navigation = styled.div(_templateObject3());
var Footer = styled.div(_templateObject4());
export var MobileView = function MobileView(_ref) {
  var className = _ref.className,
      content = _ref.content,
      navigation = _ref.navigation,
      footer = _ref.footer;
  return /*#__PURE__*/React.createElement(Container, {
    className: className
  }, navigation && /*#__PURE__*/React.createElement(Navigation, null, navigation), /*#__PURE__*/React.createElement(Content, {
    hasNavigation: !!navigation
  }, content), footer && /*#__PURE__*/React.createElement(Footer, null, footer));
};